export const BANK_DISBURSMENT_REPORT_STATE = {
    report_month: ""
}